import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import ModeEditIcon from '@material-ui/icons/ModeEdit'
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash'
import { reduxForm} from 'redux-form'
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Text from '../../../../../uis/form/text';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    }
})

const validate = values => {
    const errors = {}
    if (!values.name) {
      errors.name = '必填'
    }
    if (!values.value) {
      errors.value = '必填'
    }
    return errors
}
class AddDialog extends React.Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Text name="name" label="名称" placeholder="名称" className={classes.textField} required={true} />
                    <Text name="value" label="数值" placeholder="数值" className={classes.textField} required={true} />
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    <Text name="name" label="名称" placeholder="名称" className={classes.textField} required={true} />
                    <Text name="value" label="数值" placeholder="数值" className={classes.textField} required={true} />
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = reduxForm({
    form: 'globalSetAddForm',
    validate
})(AddDialog)

const UpdateFormDialog = connect(
    state => ({
      initialValues: state.global.detail
    }),
  )(reduxForm({
    form: 'globalSetUpdateForm'
})(UpdateDialog))

class GlobalSet extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target.value})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal} = this.props
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['全局设置_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                    </Grid>
                    <Grid item>
                        <TextField
                            select
                            label="选择筛选条件"
                            margin="normal"
                            style={{minWidth: 200}}
                            onChange={(event) => this.handleFiltersClick(event.target.value)}
                        >
                            {filterList.filter(item => !item.isShow).map((item, index) => {
                                return (
                                    <MenuItem
                                        key={index}
                                        value={item.value}
                                    >
                                        {item.name}
                                    </MenuItem>
                                );
                            })}
                        </TextField>
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>名称</TableCell>
                                <TableCell>数值</TableCell>
                                {(permissionMap['全局设置_修改'] || permissionMap['全局设置_删除']) && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell className={classes.contentCell}>{row.value}</TableCell>
                                        {(permissionMap['全局设置_修改'] || permissionMap['全局设置_删除']) && <TableCell>
                                            {permissionMap['全局设置_修改'] && <Tooltip title="修改">
                                                <IconButton color="primary" onClick={()=>dispatch(actions.showUpdateModal(row.id))}><ModeEditIcon /></IconButton>
                                            </Tooltip>}
                                            {permissionMap['全局设置_删除'] && <Tooltip title="删除">
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}><ClearIcon /></IconButton>
                                            </Tooltip>}
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.global,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(GlobalSet))


// WEBPACK FOOTER //
// ./src/pages/home/routes/global/components/list.js